import React from 'react';
import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useGetCompanies } from '@/hooks/useGetCompanies';
import { SelectOptions } from '@/components/ui/SelectOptions';
import { FormItemWrapper } from '@/components/Settings/DataExtraction/styles';

const { useFormInstance, useWatch } = Form;

export function CompanyFormItem(): JSX.Element {
	const form = useFormInstance();
	const organization_id = useWatch('organization_id');

	const { isLoading: isLoadingCompanies, data: companies = [] } = useGetCompanies({
		organization_id
	});

	function handleOnChange(): void {
		form.resetFields(['sector_id', 'line_id', 'workstation_id']);
	}

	const isLoading = !!organization_id && isLoadingCompanies;

	return (
		<FormItemWrapper name="company_id" label={I18n.get('Industrial site')} labelCol={{ span: 24 }}>
			<SelectOptions
				allowClear
				options={companies}
				onChange={handleOnChange}
				disabled={!organization_id}
				loading={isLoading}
				placeholder={I18n.get('Industrial site')}
			/>
		</FormItemWrapper>
	);
}
